import { useMediaQuery } from "react-responsive";
import { useState, useEffect } from "react";

export default (query) => {
    const isTrueQuery = useMediaQuery(query);
    const [ isTrue, setIsTrue ] = useState(false);

    useEffect(() => {
        setIsTrue(isTrueQuery);
    }, [isTrueQuery]);

    return isTrue
}
